import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import registry from "../../data/blogMetadata.json";

const normalizePath = (value = "/") => {
  const path = value.replace(/\/+$/, "") || "/";
  return path.toLowerCase();
};

const postsByPath = Object.values(registry.posts).reduce((posts, post) => {
  posts[normalizePath(post.canonicalPath)] = post;
  return posts;
}, {});

const absoluteUrl = (path) => `${registry.siteUrl}${path}`;

const BlogMetadata = () => {
  const { pathname } = useLocation();
  const normalizedPath = normalizePath(pathname);
  const entry = normalizedPath === "/blog" ? registry.index : postsByPath[normalizedPath];

  if (!entry) {
    return null;
  }

  const canonicalUrl = absoluteUrl(entry.canonicalPath);
  const description = entry.socialDescription || entry.description;
  const type = entry.type || "article";
  const author = entry.author || registry.defaultAuthor;

  return (
    <Helmet prioritizeSeoTags>
      <title>{entry.title}</title>
      <meta name="description" content={entry.description} />
      <meta name="keywords" content={entry.keywords} />
      <meta name="robots" content={registry.robots} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:site_name" content={registry.siteName} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={entry.title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      {type === "article" && author ? <meta property="article:author" content={author} /> : null}
      {entry.publishedTime ? <meta property="article:published_time" content={entry.publishedTime} /> : null}
      {entry.modifiedTime ? <meta property="article:modified_time" content={entry.modifiedTime} /> : null}
      {author ? <meta name="author" content={author} /> : null}
      <meta name="twitter:title" content={entry.title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default BlogMetadata;
